import { useCallback } from 'react';
import { CORE_LIVE_VIEW } from '@/features/plugins/core-panels';
import { dockApp } from '@/lib/desktop-shell/app-panels';
import { useDesktopShellStoreApi } from '@/lib/desktop-shell/store-context';

/**
 * Opens Live (D28): the call with the voice of the place the user is in, its tab docked in the
 * conversation on screen, which the call starts from (what is on screen comes first).
 */
export function useOpenLive(): () => Promise<void> {
  const store = useDesktopShellStoreApi();
  return useCallback(async () => {
    dockApp(store, CORE_LIVE_VIEW);
  }, [store]);
}
